import { render, staticRenderFns } from "./EditApiKeysButton.vue?vue&type=template&id=53b2529a&scoped=true"
import script from "./EditApiKeysButton.vue?vue&type=script&lang=js"
export * from "./EditApiKeysButton.vue?vue&type=script&lang=js"
import style0 from "./EditApiKeysButton.vue?vue&type=style&index=0&id=53b2529a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2529a",
  null
  
)

export default component.exports